import {Map} from "@luciad/ria/view/Map";
import React, {PropsWithChildren} from "react";
import "./BottomLeftOverlay.css";
import {CompassButton} from "./CompassButton";
import {ZoomControl} from "./ZoomControl";

interface Props {
  map: Map;
  zoomControl?: ((map: Map) => JSX.Element) | null;
  compass?: ((map: Map) => JSX.Element) | null;
}

export const BottomLeftOverlay = ({
                                    map,
                                    zoomControl = map => <ZoomControl map={map}/>,
                                    compass = map => <CompassButton map={map}/>,
                                    children,
                                  }: PropsWithChildren<Props>) => {
  return (
      <div className="bottom-left-buttons">
        {zoomControl && zoomControl(map)}
        {compass && compass(map)}
        {children}
      </div>
  );
};
